import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import GoogleButton from "@/components/GoogleButton";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user !== false) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      if (data.access_token) localStorage.setItem("access_token", data.access_token);
      setUser(data);
      toast.success("Account creato! Crea il tuo primo matrimonio.");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore di registrazione");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grain py-12">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex justify-center mb-8" data-testid="register-brand-link">
          <img src="/brand/logo-black.png" alt="ourweddly" className="h-12 w-auto" />
        </Link>
        <p className="eyebrow mb-3 text-center">Inizia gratis</p>
        <h1 className="font-wed text-4xl mb-8 text-center">Crea il tuo account</h1>
        <div className="bg-white border rounded-3xl p-8 space-y-5" style={{ borderColor: "#e3ddd2" }}>
          <GoogleButton label="Registrati con Google" />
          <div className="flex items-center gap-4">
            <div className="h-px flex-1 bg-[#e3ddd2]" />
            <span className="text-xs text-neutral-400 uppercase tracking-wider">oppure</span>
            <div className="h-px flex-1 bg-[#e3ddd2]" />
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="label-wed">Nome</label>
              <input className="input-wed" value={name} onChange={(e) => setName(e.target.value)} placeholder="Il tuo nome" data-testid="register-name-input" />
            </div>
            <div>
              <label className="label-wed">Email</label>
              <input className="input-wed" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.it" data-testid="register-email-input" />
            </div>
            <div>
              <label className="label-wed">Password</label>
              <input className="input-wed" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Almeno 6 caratteri" data-testid="register-password-input" />
            </div>
            <button type="submit" className="btn-wed w-full" disabled={loading} data-testid="register-submit-button">
              {loading ? "Creazione…" : "Crea account"}
            </button>
          </form>
        </div>
        <p className="text-center text-sm text-neutral-500 mt-6">
          Hai già un account?{" "}
          <Link to="/login" className="font-medium" style={{ color: "var(--wed-primary)" }} data-testid="register-to-login-link">Accedi</Link>
        </p>
        <p className="text-center text-xs text-neutral-400 mt-4">
          Creando un account accetti la nostra{" "}
          <Link to="/privacy" className="underline">informativa sulla privacy</Link>.
        </p>
      </div>
    </div>
  );
}
